import moment from 'moment'
import { useState } from 'react'
import { FaEllipsisV, FaStar, FaTrash } from 'react-icons/fa'
import { useNavigate, useParams } from 'react-router-dom'
import { api } from '../app/Api/ApiSlice'
import { toast } from 'react-toastify'




const SuggestionMessage = ({ sugg }) => {
    const [focusedImg, setFocusedImg] = useState(sugg?.filesUrls?.length > 0 && sugg.filesType === "images" ? sugg.filesUrls[0] : null)

    const navigate = useNavigate()
    const {organization} = useParams()

    const markMsg = async (id) => {
        try {
            const response = await api.patch(`/${organization}/suggestions/${id}`)
            if (response.status === 200) {
                toast.success("suggestion message marked")
            }

        } catch (error) {
            toast.error(error.response.data.message)
        }
    }
    const deleteMsg = async (id) => {
        try {
            const response = await api.delete(`/${organization}/suggestions/${id}`)
            if (response.status === 200) {
                toast.success("suggestion message deleted")
            }

        } catch (error) {
            toast.error(error.response.data.message)
        }
    }
    return (
        <div>
            <div className="suggestion-msg-header">
                <p>{moment(sugg.createdAt).fromNow()}</p>
                <FaEllipsisV />
            </div>
            <div className="post-body">
                {
                    sugg?.message &&
                    <div className="feed-post-text"
                        onClick={() => navigate(`/suggestion/${sugg._id}`, { state: { sugg } })}
                    >
                        <p>{sugg.message.substring(0, 100)}</p>
                    </div>
                }
                {sugg.filesUrls?.length > 0 &&
                    <div className="postcard-images">
                        {

                            (() => {
                                switch (sugg.filesType) {
                                    case "images":
                                        return <div className="post-images">
                                            <div className="focused-image">
                                                <img src={focusedImg} alt="" />
                                            </div>
                                            <div className="image-list">
                                                {
                                                    sugg.filesUrls.length > 0 &&
                                                    <div className='image-selector'>

                                                        {
                                                            sugg.filesUrls.map((image, i) => (
                                                                <div
                                                                    className='image-selector-wrapper'
                                                                    key={i}
                                                                    onClick={() => setFocusedImg(image)}>
                                                                    <img src={image} alt="" />
                                                                </div>
                                                            ))

                                                        }
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    case "video":
                                        return <div className='video-container'>
                                            <video controls>
                                                <source src={sugg.filesUrls[0]} type='video.mp4' />
                                            </video>
                                        </div>
                                }
                            })()}
                    </div>
                }
            </div>
            <div className="suggestion-msg-footer">
                <button className="suggestion-msg-btn" onClick={() => markMsg(sugg._id)}>{sugg.important ? <FaStar /> : <FaStar />}</button>
                <button className="suggestion-msg-btn" onClick={() => deleteMsg(sugg._id)}><FaTrash /></button>
            </div>
        </div>
    )
}

export default SuggestionMessage